export type AuthMethod =
    | 'nao_logado'
    | 'logado_sessao_ativa'
    | 'nao_logado_email_senha'
    | 'nao_logado_google'
    | 'nao_logado_cadastro_novo'
    | 'trocando_conta'

const DEFAULT_METHOD: AuthMethod = 'nao_logado'

/**
 * Guardado em memória (não em sessionStorage/cookie) de propósito: precisa
 * resetar a cada refresh, pra "sessão já ativa" ser recalculada a cada
 * carregamento de página, mas continuar estável entre as telas do checkout
 * enquanto não houver um novo refresh.
 */
let currentMethod: AuthMethod = DEFAULT_METHOD

export const getAuthMethod = (): AuthMethod => {
    if (typeof window === 'undefined') return DEFAULT_METHOD
    return currentMethod
}

/**
 * Sobrescreve o método sempre. Usar no momento em que o sistema identifica
 * como a pessoa entrou (login por senha, cadastro, Google) — se a pessoa
 * se logar de novo com outro método, o método persistido passa a ser o novo.
 */
export const setAuthMethod = (method: AuthMethod): void => {
    if (typeof window === 'undefined') return
    currentMethod = method
}

/**
 * Só grava se o método ainda estiver no valor padrão (nao_logado). Usar para
 * a detecção passiva de sessão já ativa, que não deve sobrescrever um método
 * explícito já identificado neste mesmo carregamento de página.
 */
export const setAuthMethodIfDefault = (method: AuthMethod): void => {
    if (typeof window === 'undefined') return
    if (currentMethod === DEFAULT_METHOD) {
        currentMethod = method
    }
}
